/**
 * Utility functions for menu data processing
 */

/**
 * Capitalizes menu name: first letter uppercase, rest lowercase
 * @param name The menu name to capitalize
 * @returns Properly capitalized menu name
 */
export function capitalizeMenuName(name: string): string {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

/**
 * Transforms menu_name fields in menu items array
 * @param menuItems Array of menu items with menu_name field
 * @returns Array with capitalized menu_name fields
 */
export function transformMenuNames(menuItems: any[]): any[] {
  if (!Array.isArray(menuItems)) return menuItems;
  
  return menuItems.map(item => ({
    ...item,
    menu_name: item.menu_name ? capitalizeMenuName(item.menu_name) : item.menu_name
  }));
}

/**
 * Transforms menu_name fields in menu data object
 * @param menuData Menu data object containing menu array
 * @returns Menu data with capitalized menu_name fields
 */
export function transformMenuData(menuData: any): any {
  if (!menuData) return menuData;
  
  return {
    ...menuData,
    menu: menuData.menu ? transformMenuNames(menuData.menu) : menuData.menu
  };
}